import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { centralGasesData } from "./centralGasesData";
import MetaInformation from "../../utils/meta/MetaInformation";
import "../accessories/Accessories.scss";
const CentralGas = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <MetaInformation
        title="Central Gas - HERZMANN"
        name="description"
        content="All Central Gases Equipment"
      />
      <main className="Accessories_Main">
        <Container fluid="lg">
          <Row>
            <Col className="text-center p-md-3">
              <h2>Central Gas</h2>
              <article className="mt-5">
                {centralGasesData[0].instruments.map((state, index) => {
                  return (
                    <Link
                      to={`/centralgas/${state?.title
                        .split(/[-\s]+/)
                        .join("-")
                        .toLowerCase()}`}
                      state={{
                        filteredArray: centralGasesData[0].instruments,
                        title: state?.title,
                      }}
                      key={index}
                      className="rounded"
                    >
                      <Card>
                        <span>
                          <img
                            src={state.image}
                            alt="instrument"
                            className={
                              state.title === "Critical Area Bed Head Units" ||
                              state.title === "Patient Bed Head Units"
                                ? "bed-units"
                                : ""
                            }
                          />
                        </span>
                        <p>{state.title}</p>
                      </Card>
                    </Link>
                  );
                })}
              </article>
            </Col>
          </Row>
        </Container>
      </main>
    </>
  );
};
export default CentralGas;
